import { t } from '@lingui/macro'
import { useLingui } from '@lingui/react'
import { Stack, Tab, Tabs } from '@mui/material'
import { z } from 'zod'

import PageContainer from '@/components/ui/containers/PageContainer'
import { useQueryParam } from '@/hooks/useQueryParam'
import { IdentityJustificationConfigTable } from './IdentityJustificationConfigTable'
import { InsAuditLogs } from './InsAuditLogs'
import { InsWorklist } from './InsWorklist'
import { TrustedActors } from './TrustedActors'

enum AdminInsiTab {
  TRUSTED_ACTORS = 'trusted-actors',
  IDENTITY_JUSTIFICATION = 'identity-justification',
  INS_AUDIT_LOGS = 'insi-traces',
  INS_WORKLIST = 'ins-worklist',
}

function validateAdminInsiTab(value: string | null): AdminInsiTab {
  return z.nativeEnum(AdminInsiTab).catch(AdminInsiTab.IDENTITY_JUSTIFICATION).parse(value)
}

export function AdminInsiPage() {
  const lingui = useLingui()
  const [tab, setTab] = useQueryParam('tab', validateAdminInsiTab)

  return (
    <PageContainer>
      <Stack spacing={2}>
        <Tabs value={tab} onChange={(_event, newValue) => setTab(newValue)} variant="scrollable">
          <Tab label={lingui._(t`Trusted actors`)} value={AdminInsiTab.TRUSTED_ACTORS} />
          <Tab label={lingui._(t`Identity justification`)} value={AdminInsiTab.IDENTITY_JUSTIFICATION} />
          <Tab label={lingui._(t`INSi traces`)} value={AdminInsiTab.INS_AUDIT_LOGS} />
          <Tab label={lingui._(t`Liste de travail INSi`)} value={AdminInsiTab.INS_WORKLIST} />
        </Tabs>

        {tab === AdminInsiTab.TRUSTED_ACTORS && <TrustedActors />}
        {tab === AdminInsiTab.IDENTITY_JUSTIFICATION && <IdentityJustificationConfigTable />}
        {tab === AdminInsiTab.INS_AUDIT_LOGS && <InsAuditLogs />}
        {tab === AdminInsiTab.INS_WORKLIST && <InsWorklist />}
      </Stack>
    </PageContainer>
  )
}

export default AdminInsiPage
